module.exports = __webpack_public_path__ + "media/KZ-AS.cc56a236.ogg";